<template>
  <div class="app">
    <router-view name="header" />
    <router-view class="default"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.axios.get('auth/user')
      .then((res) => {
        const info = res.data;
        this.$store.state.authInfo.id = info.id;
        this.$store.state.authInfo.email = info.email;
        this.$store.state.authInfo.preName = info.preName;
        this.$store.state.authInfo.lastName = info.lastName;
        this.$store.state.authInfo.permissions = info.permissions;
        this.$store.state.loggedIn = true;
        const redirect = this.$router.currentRoute.query.redirect.toString();
        if (redirect) this.$router.push(redirect);
      });
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";
@import "~@/fonts/Poppins/Poppins";
@import "~@/assets/scss/text";
@import "~@/assets/scss/colors";
@import "~@/assets/scss/components";

html, body {
  background-color: var(--background-color);
  color: var(--light-background-color);
  font-size: 16px;
  font-family: Poppins-Regular, Helvetica, Arial, sans-serif;
  scroll-behavior: smooth;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.full {
  display: flex;
  flex-grow: 1;
}

.centered {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100vw;
  max-width: 100%;
}
</style>
